import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Filter from './UI.List.Filter';
import PageUi from 'kts-platform-frame/display/components/PageUi';
import moment from 'moment';
import { Form, Table, Tag, Button, Card, Col, Row, message, Modal } from 'antd';
import Field from 'kts-scaffold-framework/utils/doc/Field';
import { history } from 'kts-platform-frame/routes';
import { outputApi } from '../../../api';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import UIRefuse from './UI.Refuse';
const css = require('./index.scss');
const FormItem = Form.Item;
const confirm = Modal.confirm;
/** Redux接口 */
interface IReduxStatePart {
    companyId?: string;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/**
 * 模块状态
 */
export class DetailState {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    companyId: state.user.currentcompanyId,
}))
export default class UIDetail extends UIBasic<IProps, ModulesState, any> {
    /**
     * 
     * @param {*进项结算单详情} props 
     */
    public columns = [
        {
            title: "序号",
            dataIndex: "supplierName",
            key: 'supplierName',
            width: 60,
            render: (text, _, index) => {
                return (
                    <div className="text-center">{((index + 1) + (this.state.pageNum - 1) * this.state.pageSize)}</div>
                );
            }
        },
        {
            title: "税务编码",
            dataIndex: "taxCode",
            width: 150,
            render: (text, record) => {
                return (
                    <div>
                        {text}
                    </div>
                );
            }
        },
        {
            title: "货物（劳务）名称",
            dataIndex: "name",
            key: 'name',
            width: 150,
            render: (text, record) => {
                return (
                    <div>
                        {text}
                    </div>
                );
            }
        },
        {
            title: "规格型号",
            dataIndex: "specification",
            render: (text, record) => {
                return (
                    <div>
                        {text}
                    </div>
                );
            }
        },
        {
            title: "数量",
            dataIndex: "quantity",
            render: (text, record) => {
                return <span> {text} </span>;
            }
        },
        {
            title: "单价",
            dataIndex: "unitPrice",
            render: (text, record) => {
                return <span> {'¥' + Field.formatMoney(text, 15)} </span>;
            }
        },
        {
            title: "无税金额",
            dataIndex: "amountWithoutTax",
            render: (text, record) => {
                return <span>{'¥' + Field.formatMoney(text, 2)}</span>;
            }
        },
        {
            title: "税率",
            dataIndex: "taxPercent",
            render: (text, record) => {
                return <span>{text}</span>;
            }
        },
        {
            title: "税额",
            dataIndex: "amountTax",
            render: (text, record) => {
                return <span>{'¥' + Field.formatMoney(text, 2)}</span>;
            }
        },
        {
            title: "价税合计",
            dataIndex: 'amount',
            render: (text, record) => {
                return <span>{'¥' + Field.formatMoney(text, 2)}</span>;
            }
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);

        this.state = {
            data: null,
            pageSize: 10,
            pageNum: 1,
            noticeId: JSString.queryStringParse(this.props.location.search).noticeId,
            companyId: this.props.companyId,
            countData: null,
            showModal: false,
        };
    }
    componentDidMount() {
        this.onReload();
    }
    onRecord = () => {
        let data = this.state.data;
        history.push({ pathname: 'detail/makeInvoice', state: data });
    }
    onMakeInvoice = () => {
        let data = [this.state.noticeId];
        outputApi.outputCreate(this, data).then((response: any) => {
            const res = response.res;
            if (res) {
                if(res.length>0){
                    message.error(res[0].msg);
                    this.onReload();
                }
                //history.push({ pathname: 'detail/makeInvoice', state: this.state.data });
            }

        });
    }
    onReload = () => {
        outputApi.outputDetail(this, { noticeId: this.state.noticeId }).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        data: res
                    });
                }
            }
        });
    }
    refush = str => {
        this.setState({
            showModal: false
        });
        let noticeArray = { noticeIdList: [this.state.noticeId], refusedReason: str };
        outputApi.outputRefuse(this, noticeArray).then((response: any) => {
            const res = response.res;
            if (res) {
                message.success('操作成功');
                this.onReload();
            }
        });

    }
    doAccept = () => {
        let noticeArray = [this.state.noticeId];
        outputApi.outputAccept(this, noticeArray).then((response: any) => {
            const res = response.res;
            if (res) {
                message.success('操作成功');
                this.onReload();
            }
        });
    }
    showDeleteConfirm = () => {
        confirm({
            title: '取消开票将会清除当前结算单所有开票记录！！',
            okText: '确认',
            okType: 'danger',
            cancelText: '取消',
            onOk: () => {
                this.onDisMakeInvoice();
            }
        });
    }
    //取消开票
    onDisMakeInvoice = () => {
        let data = [this.state.noticeId];
        outputApi.outputCancel(this, data).then((response: any) => {
            const res = response.res;
            if (res) {
                message.success('操作成功');
                this.onReload();
            }
        });
    }
    openModal = () => {
        this.setState({
            showModal: true
        });
    }
    onCloseModal = () => {
        this.setState({
            showModal: false
        });
    }
    onPagination = (pagination, filters, sorter) => {
        console.log(pagination.current);
        /* this.setState({
            pageNum:pagination.current
        }) */
    }
    render() {
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
        };
        const { data } = this.state;
        const _datasource = data && data.noticeBillDetailList.map((item, index) => {
            return {
                ...item,
                index
            };
        });
        return (
            <div>
                {(!this.props.children && data) &&
                    <Card
                        title='企业销项结算清单'
                        extra={
                            <div>
                                {data.makeInvoiceState === 1 &&
                                    <Button type="primary" onClick={this.onRecord}>开票记录</Button>
                                }
                                {(data.makeInvoiceState === 1 && data.noticeBillState !== 'INVALID') && <Button type="danger" onClick={this.showDeleteConfirm} className="ml-10">取消开票</Button>}
                                {(data.makeInvoiceState === 0 && data.noticeBillState === 'ACCEPTED') && <Button type="primary" className="ml-10" onClick={() => { this.onMakeInvoice(); }}>开票</Button>}
                                {data.noticeBillState === 'SENDED' && <span><Button type="default" className="ml-10" onClick={() => { this.doAccept(); }}>接受</Button>
                                    <Button type="default" className="ml-10" onClick={() => { this.openModal(); }}>拒绝</Button></span>}
                                {data.noticeBillState === 'REFUSED' && <Button type="default" className="ml-10" onClick={() => { this.doAccept(); }}>接受</Button>}
                                <Button className="ml-10" onClick={() => { history.goBack(); }}>返回</Button>
                            </div>}
                    >
                        <Row className={css['no-bottom']}>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="单号"
                                >
                                    <span className="ant-form-text">{data.bizNoticeId}</span>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="时间"
                                >
                                    <span className="ant-form-text">{Field.formatDate(data.createTime)}</span>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="购方名称"
                                >
                                    <span >{data.buyerName}</span>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="总税额"
                                >
                                    <span className="ant-form-text">{Field.formatMoney(data.amountTax, 2)}</span>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="销方名称"
                                >
                                    <span >{data.supplierName}</span>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="价税合计"
                                >
                                    <span className="ant-form-text">{Field.formatMoney(data.amountSum, 2)}</span>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="结算时间"
                                >

                                    <span className="ant-form-text">
                                        {Field.formatDate(data.settlBeginTime)}
                                        {(data.settlBeginTime || data.settlEndTime) && '至'}
                                        {Field.formatDate(data.settlEndTime)}</span>

                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="总金额"
                                >
                                    <span className="ant-form-text">{Field.formatMoney(data.amountWithoutTax, 2)}</span>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="结算部门"
                                >
                                    <span className="ant-form-text">{data.supplierDepartment}</span>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="状态"
                                >
                                    {data.makeInvoiceState === 1 && <Tag color='green'>已开票</Tag>}
                                    {data.noticeBillState === 'CREATED' && <Tag color='green'>已送达</Tag>}
                                    {data.noticeBillState === 'SENDED' && <Tag color='green'>已发送</Tag>}
                                    {data.noticeBillState === 'ACCEPTED' && <Tag color='green'>接受</Tag>}
                                    {data.noticeBillState === 'REFUSED' && <Tag color='red'>拒绝</Tag>}
                                    {data.noticeBillState === 'INVALID' && <Tag color='orange'>作废</Tag>}
                                </FormItem>
                            </Col>
                            {data.refusedReason && <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="拒绝原因"
                                >
                                    <span style={{ overflow: 'hidden', 'maxWidth': '100%', textOverflow: 'ellipsis', display: 'inline-block' }}>{data.refusedReason}</span>
                                </FormItem>
                            </Col>
                            }
                            <Col span={12}>
                                <FormItem
                                    {...formItemLayout}
                                    label="备注"
                                >
                                    <span className="ant-form-text scroll-text">{data.remark}</span>
                                </FormItem>
                            </Col>
                        </Row>
                        <Table
                            columns={this.columns}
                            dataSource={_datasource}
                            pagination={false}
                            rowKey="index"
                            onChange={this.onPagination}
                        />
                        <div className="pull-right" style={{ 'marginTop': '16px' }}>
                            <span style={{ 'marginRight': '25px' }}>合计</span>
                            <span style={{ 'marginRight': '10px' }}>无税金额 </span><span className="bold_number">  ¥{Field.formatMoney(data.amountWithoutTax, 2)}</span>
                            <span style={{ 'padding': '0 15px' }}>|</span><span style={{ 'marginRight': '10px' }}>税额 </span><span className="bold_number"> ¥{Field.formatMoney(data.amountTax, 2)}</span>
                            <span style={{ 'padding': '0 15px' }}>|</span><span style={{ 'marginRight': '10px' }}>价税合计 </span><span className="bold_number"> ¥{Field.formatMoney(data.amountSum, 2)}</span>
                        </div>
                    </Card>}
                {this.state.showModal &&
                    <UIRefuse
                        onCloseModal={this.onCloseModal}
                        refush={this.refush}
                    />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/OutputSettlement/UI.Detail.tsx